import { NewsLetterAssests } from './types/newsletter.types';
import BannerImage from './assets/card-banner.svg';
import leftArrow from './assets/left-arrow.svg';
import rightChevGray from './assets/rightChevGray.svg';
import attentionIcon from './assets/attention-icon.svg';

export const NEWSLETTER_ASSETS: NewsLetterAssests = {
  BANNER_IMAGE: BannerImage,
  LEFT_ARROW: leftArrow,
  RIGHT_CHEV_GRAY: rightChevGray,
  ATTENTION_ICON: attentionIcon,
};
